import { useState, useEffect } from 'react';
import { Container, Card, Spinner, Button, Table, Col, Row, Alert } from 'react-bootstrap';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import axios from '../../../api/axios';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { axiosPrivate } from '../../../hooks/axiosPrivate';
import axiosIntsance from '../../../api/userApi';
import $ from 'jquery';
import { useLocation, Link, useNavigate } from 'react-router-dom';

 

const AllCustomers = () => {
 
    const navigate = useNavigate();



    
   


        //initialize datatable
        $(document).ready(function () {
          setTimeout(function(){
        if ( $.fn.dataTable.isDataTable( '#example' ) ) {
          const  table = $('#example').DataTable();
          }
          else {
            const  table = $('#example').DataTable({
                  paging: true,
                  pagingType: 'full_numbers',
                  pageLength: 5,
                  processing: true,
                  dom: 'Bfrtip',
                  buttons: ['copy', 'csv', 'print'],
                  destroy: true,
                    
              });
          }
          
          } ,
          1000
          );
      });

    //   let content;
    //     if(isLoading) {
    //       content=<p>Loading...</p>
    //     }else if (isSuccess){
    //       content = supplier.map(sup => {
    //         return (
    //           <tr key={sup.id}>
    //           <td>{sup.id}</td>
    //           <td>{sup.supplier_code}</td>
    //           <td>{sup.supplier_name}</td>
    //           <td>{sup.contact_person}</td>
    //           <td>{sup.email_id}</td>
    //           <td>{sup.mobile_no}</td>
    //           <td><> <Button className="btn btn-sm btn-warning" /* onClick={(e) => onSupplierModify(supplier.id,e)} */ id={sup.id} onChange={() => updateSupplier({...supplier, completed:!sup.completed})}><FaEdit className='fwcolor' /></Button> <Button className="btn btn-sm btn-danger" /* onClick={(e) => onSupplierDelete(supplier.id, e)} */ onClick={()=> deleteSupplier({ id: sup.id})}><FaTrash className='fwcolor' /></Button></></td>
    //         </tr>
    //         )
    //       })
    //     }else if (isError) {
    //       content = <p>{error}</p>
    //     }
  return (
    <>
      
    <div className="my-4  container-xl">
    <div class="card">
    <div class="card-header">
    <h3   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Customers List</h3>
  </div>
  <div class="card-body">
  <Row>
    <Col>
    {/* {content} */}
        {/* {status && (<Alert variant={status === "success" ? "success" : "danger"}>{status === "success" ? msgSuccess : msgError}</Alert>)} */}
    </Col>
</Row>

    <table id="example" class="table table-hover table-bordered display" style={{"width":"100%"}}>
    <thead>
      <tr>
        <th>ID</th>
        <th>Image</th>
        <th>Title</th>
        <th>First Name</th>
        <th>Last Name</th>
        <th>Email</th>
        <th>Password</th>
        <th>Contactno</th>
        <th>Country</th>
        <th>Country_code</th>
        <th>Status</th>
        
      </tr>
    </thead>
    <tbody>
  
      
    </tbody>
  </table>
    
 
  </div>
</div>
   



</div>
    {/* <article>
      <h2>Customers List</h2>
    
      
    </article> */}
    </>
  )
}

export default AllCustomers;
